import { defineApi } from '@/utils/fetch';

import type { IOssStsData, IPostCreateUserFeedbackData, IUserProfileData } from './typings';

export const UserApi = {
    postCreateUserFeedback: defineApi<IPostCreateUserFeedbackData, undefined>({
        url: '/user/feedback/v1',
        method: 'POST',
    }),
    getUserProfile: defineApi<undefined, IUserProfileData>({
        url: '/user/profile/v1',
        method: 'GET',
    }),
    getOssSts: defineApi<undefined, IOssStsData>({
        url: '/user/oss/sts',
        method: 'GET',
    }),
};

export * from './typings';
